module.exports = __webpack_public_path__ + "static/media/testimonial-image-02.fda6a872.jpg";